import { LOYALTY_ERROR, SET_LOYALTY } from '../types/LoyaltyTypes';
import { callGetUserCategory } from '../../services/LoyaltyService';

export const errorInGetCategories = () => {
  return { type: LOYALTY_ERROR };
};

export const setLoyalty = (category) => {
  return { type: SET_LOYALTY, category };
};

export const getUserCategory = () => {
  return async (dispatch, getState) => {
    try {
      const { logonId } = getState().profileReducer.profile;
      const res = await callGetUserCategory(logonId);
      const { category } = res.data;
      if (res.status !== 200) dispatch(errorInGetCategories());
      else dispatch(setLoyalty(category));
    } catch (e) {
      dispatch(errorInGetCategories());
    }
  };
};
